// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/paragraph/ParagraphCardGroup.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/paragraph/ParagraphCardGroup.tsx");
  import.meta.hot.lastModified = "1773385375629.8064";
}
// REMIX HMR END

import clsx from "clsx";
import Heading from "../Heading";
import { default as Card } from "./ParagraphCard";
const variants = {
  primary: {
    wrapper: "bg-neutral-100",
    text: "text-neutral-600 text-center mb-8 md:mb-4",
    title: "text-center",
    grid: "grid gap-10"
  },
  secondary: {
    wrapper: "bg-white gap-4",
    text: "text-neutral-600 w-full text-mb-8 md:left",
    title: "text-center",
    grid: "grid gap-y-8 md:gap-x-20"
  },
  tertiary: {
    wrapper: "bg-white",
    text: "text-neutral-600 text-center mb-8 md:mb-4",
    title: "text-center",
    grid: "grid gap-10"
  },
  quaternary: {
    wrapper: "w-full",
    text: "text-neutral-600 text-center mb-8 md:mb-4",
    title: "",
    grid: "grid gap-10"
  }
};
const Columns = {
  1: {
    primary: "grid-cols-1",
    secondary: "grid-cols-1",
    tertiary: "grid-cols-1"
  },
  2: {
    primary: "grid-cols-1 md:grid-cols-2 md:gap-x-12 md:gap-y-8",
    secondary: "md:grid-cols-2",
    tertiary: "grid-cols-1 md:grid-cols-2 md:gap-x-12 md:gap-y-8"
  },
  3: {
    primary: "grid-cols-1 md:grid-cols-3 md:gap-x-8 md:gap-y-8",
    secondary: "md:grid-cols-3",
    tertiary: "grid-cols-1 md:grid-cols-3 md:gap-x-8 md:gap-y-8",
    quaternary: "grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 w-full"
  },
  4: {
    primary: "grid-cols-1 xl:grid-cols-4",
    secondary: "md:grid-cols-4"
  },
  5: {
    primary: "grid-cols-1 xl:grid-cols-5",
    secondary: "md:grid-cols-5"
  },
  6: {
    primary: "grid-cols-1 md:grid-cols-3",
    secondary: "md:grid-cols-6"
  },
  7: {
    primary: "grid-cols-1 xl:grid-cols-7",
    secondary: "md:grid-cols-7"
  },
  8: {
    primary: "grid-cols-1 xl:grid-cols-8",
    secondary: "md:grid-cols-8"
  }
};
export default function CardGroup({
  columns,
  items,
  textOptional,
  titleOptional,
  variant
}) {
  const {
    wrapper,
    text,
    grid,
    title
  } = variants[variant];
  const columnsClass = variant === "quaternary" ? Columns[3] : columns ? Columns[columns] : Columns[3];
  const createCardItem = item => {
    if ("referenceContent" in item) {
      if (!item.referenceContent) {
        return false;
      }
      const obj = {
        imageOptional: item.referenceContent.heroImage || item.referenceContent.image,
        title: item.referenceContent.title,
        text: {
          __typename: "Text",
          processed: item.referenceContent.abstract
        },
        cta: [{
          title: item.ctaText,
          url: item.referenceContent.path,
          __typename: "Link",
          internal: true
        }]
      };
      return obj;
    }
    return {
      ...item
    };
  };
  return <section className={clsx("flex flex-col items-center", wrapper)}>
      <hgroup className="w-full">
        {titleOptional && <Heading tag="h2" className={title}>
            {titleOptional}
          </Heading>}
        {textOptional && <div className={clsx(text)} dangerouslySetInnerHTML={{
        __html: textOptional.processed
      }} />}
      </hgroup>
      <ul className={clsx(grid, columnsClass[variant])}>
        {items.map((item, index) => {
        const isReferenceContentEmpty = "referenceContent" in item && !item.referenceContent;
        if (isReferenceContentEmpty) {
          return;
        }
        return <Card key={index} variant={variant} {...createCardItem(item)} type={item.__typename} />;
      })}
      </ul>
    </section>;
}
_c = CardGroup;
var _c;
$RefreshReg$(_c, "CardGroup");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;